import { isTeamManager, hasPrivilege, USER_READ } from 'utils/privileges';
export function hasMyTeamsAccess() {
  return isTeamManager() || hasPrivilege(USER_READ);
}